import Vue from 'vue';
import Router from 'vue-router';

// Custom Theme
import routes from '@theme/router/';

// https://medium.com/hypefactors/add-i18n-and-manage-translations-of-a-vue-js-powered-website-73b4511ca69c

Vue.use(Router);

// Fix for navigation failure errors in vue-router 3.1+
// Since vue-router 3.1.0, router.push/replace return a Promise and throw errors
// for navigation failures (duplicated, redirected, cancelled, aborted).
// This patch restores the previous silent behavior for expected navigation failures.
// See: https://github.com/vuejs/vue-router/issues/2881#issuecomment-520554378
// See: https://router.vuejs.org/guide/advanced/navigation-failures.html
const navigationFailures = [
  'NavigationDuplicated',
  'NavigationCancelled',
  'NavigationRedirected',
  'NavigationAborted'
];

function isNavigationFailure(err) {
  return err && navigationFailures.includes(err.name);
}

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject);
  }
  return originalPush.call(this, location).catch((err) => {
    if (isNavigationFailure(err)) {
      return err;
    }
    throw err;
  });
};

const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject);
  }
  return originalReplace.call(this, location).catch((err) => {
    if (isNavigationFailure(err)) {
      return err;
    }
    throw err;
  });
};

const router = new Router({
  mode: 'history',
  routes: routes,
  linkActiveClass: 'active',
  linkExactActiveClass: 'active'
});

export default router;
